<template
  ><b-card
    class="bg-transparent border-0 p-2"
    no-body
    style="padding-bottom: 0;"
  >
    <b-card class="bg-white border-0 p-3" no-body style="padding-bottom: 0;">
      <b-tabs
        class="mipe-green-tabs"
        content-class="pt-4"
        no-nav-style
        v-model="tabsModel"
      >
        <b-tab
          :active="tabsModel === 0"
          title="Detalle de Servicios del Estudiante"
        >
          <div class="info-panel">
            <div class="row">
              <div class="col-12 mb-3">
                <em class="fas fa-info-circle text-orange mr-1" />
                <span>Detalle de Servicios del Estudiante</span>
              </div>
              <div class="col-12">
                <div class="row grayish-lighter no-gutters p-3">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <span class="data-label">Nombre del Referido:</span>
                    <p class="data">{{ model.fullName || "-" }}</p>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <span class="data-label">Estatus del Referido:</span>
                    <custom-balloon
                      class="mt-2 font-15"
                      :text="model.status"
                      :background-color="getStatusColor(model.statusId, '')"
                      dot
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <span class="data-label">Tipo de Servicio:</span>
                    <p class="data">{{ model.service || "-" }}</p>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <span class="data-label">Vigencia del Servicio:</span>
                    <p class="data">
                      {{ (model != null ? model.dateFrom : "") | formatDate }} -
                      {{ (model != null ? model.dateTo : "") | formatDate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-card>
</template>

<script>
const CUSTOM_DATE_FORMAT = "DD/MMM/YYYY";
import { getLastAdmission } from "@/modules/referral/api";
import moment from "moment";
import CustomBalloon from "custom-balloon";
import ThrpiesAdmissionStatuses from "@/utils/constants/thrpiesAdmissionStatuses";

export default {
  props: {
    studentSieId: {
      type: Number,
      default: undefined
    },
    disciplineTypeId: {
      type: Number,
      default: undefined
    }
  },
  components: { CustomBalloon },
  data() {
    return {
      model: {},
      tabsModel: 0
    };
  },
  async mounted() {
    await this.getLastAdmission();
  },
  filters: {
    formatDate: date => {
      if (date) {
        return moment(date)
          .locale("es")
          .format(CUSTOM_DATE_FORMAT);
      }
      return "";
    }
  },
  methods: {
    async getLastAdmission() {
      const { data } = await getLastAdmission({
        studentSieId: this.studentSieId,
        disciplineTypeId: this.disciplineTypeId
      });
      this.model = data;
    },
    getStatusColor(statusId, classPrefix) {
      switch (statusId) {
        case ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
        case ThrpiesAdmissionStatuses.ReferidoRechazado: {
          return !classPrefix ? "brown" : `${classPrefix}-active-service-brown`;
        }
        case ThrpiesAdmissionStatuses.ServicioRelacionadoActivo: {
          return !classPrefix
            ? "green-light"
            : `${classPrefix}-active-service-green`;
        }
        case ThrpiesAdmissionStatuses.Asignado:
        case ThrpiesAdmissionStatuses.Admitido:
        case ThrpiesAdmissionStatuses.Vinculado: {
          return !classPrefix
            ? "yellow"
            : `${classPrefix}-active-service-yellow`;
        }
        case ThrpiesAdmissionStatuses.NoVinculado:
        case ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro:
        case ThrpiesAdmissionStatuses.Alertas: {
          return !classPrefix ? "pink" : `${classPrefix}-active-service-pink`;
        }
        case ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional: {
          return !classPrefix
            ? "violet"
            : `${classPrefix}-active-service-violet`;
        }
        default: {
          return !classPrefix
            ? "primary-2"
            : `${classPrefix}-active-service-orange`;
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.grayish-lighter {
  background-color: #f7f7f7;
}
</style>
